import api from 'ApiConfig';

const branchService = {
  getAllBranches: async () => {
    return api.post('/superadmin/all-branch');
  },
};

export default branchService;
